module.exports = __webpack_public_path__ + "static/media/Campton-Book.4d4c1496.woff2";